class branchInfo {

    name: string = ''
    account_type: string = ''
    address: string = ''
    amount: string = ''
    average_consumption: string = ''
    average_current_year_period1: string = ''
    average_current_year_period2: string = ''
    average_current_year_period3: string = ''
    average_current_year_period4: string = ''
    average_current_year_period5: string = ''
    average_current_year_period6: string = ''
    average_last_year_period1: string = ''
    average_last_year_period2: string = ''
    average_last_year_period3: string = ''
    average_last_year_period4: string = ''
    average_last_year_period5: string = ''
    average_last_year_period6: string = ''
    bill_id: string = ''
    city: string = ''
    current_date: string = ''
    current_number: string = ''
    debt_message: string = ''
    deduction_amount_1000_rial: string = ''
    extra_consumption: string = ''
    geographical_code: string = ''
    has_debt: boolean = false
    meter_body_number: string = ''
    pay_id: string = ''
    payment_dead_line: string = ''
    postal_code: string = ''
    previous_date: string = ''
    previous_debt: string = ''
    previous_number: string = ''
    tax: string = ''
    total_consumption: string = ''
    village=""
    total_day: string = ''
    units_number: string = ''
    waste_water_price: string = ''
    water_price: string = ''
    agent_code: string = ''
    bill_exportation_date: string = ''
    bill_serial: string = ''
    selling_type: string = ''
    extra_unit: string = ''
    contract_capacity: string = ''
    meter_status: string = ''
    installation_date: string = ''
    branch_diameter: string = ''
    waste_water_diameter: string = ''
    reading_type: string = ''
    village_abfa_portion: string = ''
    amount_in_word: string = ''

    constructor(branchInfo?: any) {
        
        if(branchInfo){
            this.name = branchInfo.name
            this.debt_message = branchInfo.debt_message
            this.extra_consumption = branchInfo.extra_consumption
            this.current_number = branchInfo.current_number
            this.account_type = branchInfo.account_type
            this.average_consumption = branchInfo.average_consumption
            this.address = branchInfo.address
            this.water_price = branchInfo.water_price
            this.waste_water_price = branchInfo.waste_water_price
            this.units_number = branchInfo.units_number
            this.deduction_amount_1000_rial = branchInfo.deduction_amount_1000_rial
            this.total_day = branchInfo.total_day
            this.total_consumption = branchInfo.total_consumption
            this.previous_debt = branchInfo.previous_debt
            this.payment_dead_line = branchInfo.previous_debt
            this.pay_id = branchInfo.pay_id
            this.city= branchInfo.city
            this.meter_body_number = branchInfo.meter_body_number
            this.has_debt = branchInfo.has_debt
            this.geographical_code = branchInfo.geographical_code
            this.current_date = branchInfo.current_date
            this.average_current_year_period1 = branchInfo.average_current_year_period1
            this.average_current_year_period2 = branchInfo.average_current_year_period2
            this.average_current_year_period3 = branchInfo.average_current_year_period3
            this.average_current_year_period4 = branchInfo.average_current_year_period4
            this.average_current_year_period5 = branchInfo.average_current_year_period5
            this.average_current_year_period6 = branchInfo.average_current_year_period6
            this.average_last_year_period1 = branchInfo.average_last_year_period1
            this.average_last_year_period2 = branchInfo.average_last_year_period2
            this.average_last_year_period3 = branchInfo.average_last_year_period3
            this.average_last_year_period4 = branchInfo.average_last_year_period4
            this.average_last_year_period5 = branchInfo.average_last_year_period5
            this.average_last_year_period6 = branchInfo.average_last_year_period6
            this.agent_code= branchInfo.agent_code
            this.bill_exportation_date= branchInfo.bill_exportation_date
            this.bill_serial= branchInfo.bill_serial
            this.selling_type= branchInfo.selling_type
            this.extra_unit= branchInfo.extra_unit
            this.contract_capacity= branchInfo.contract_capacity
            this.meter_status= branchInfo.meter_status
            this.installation_date= branchInfo.installation_date
            this.branch_diameter= branchInfo.branch_diameter
            this.waste_water_diameter= branchInfo.waste_water_diameter
            this.reading_type= branchInfo.reading_type
            this.village_abfa_portion= branchInfo.village_abfa_portion
            this.village= branchInfo.village
            this.amount_in_word= branchInfo.amount_in_word
        }

    }
}

export default branchInfo;